import { render } from "./VueFollowButton.vue?vue&type=template&id=ef3cf336&ts=true&lang=pug"
import script from "./VueFollowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueFollowButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueFollowButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef3cf336"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef3cf336', __exports__)) {
    api.reload('ef3cf336', __exports__)
  }
  
  module.hot.accept("./VueFollowButton.vue?vue&type=template&id=ef3cf336&ts=true&lang=pug", () => {
    api.rerender('ef3cf336', render)
  })

}


export default __exports__